import type { CostSplitUsd, CostTokens } from './api';
import type { CostRow } from './cost-row';

/**
 * Os cartões do topo, somados a partir das linhas que sobraram do recorte.
 *
 * Antes eles vinham do total cru do período e nenhum filtro os movia: marcar
 * "Atendimento" tirava a rotina da tabela e o número grande continuava contando
 * ela. Somar o que está em tela é o que torna "tirar meus testes" possível — e
 * de quebra faz os outros filtros dizerem a verdade.
 *
 * A soma sai sempre das linhas POR CLIENTE, não da aba aberta: a visão por
 * modelo agrega origens diferentes na mesma linha e não sabe separar teste de
 * atendimento.
 */
export class PeriodTotals {
  private constructor(private readonly rows: CostRow[]) {}

  static of(rows: CostRow[]): PeriodTotals {
    return new PeriodTotals(rows);
  }

  get clientCount(): number {
    return this.rows.length;
  }

  get calls(): number {
    return this.sum((row) => row.callsCount);
  }

  get usd(): number {
    return this.sum((row) => row.usd);
  }

  get brl(): number {
    return this.sum((row) => row.totalBrl);
  }

  get unpricedCalls(): number {
    return this.sum((row) => row.unpricedCalls);
  }

  get tokens(): CostTokens {
    return {
      prompt: this.sum((row) => row.promptTokens),
      cached: this.sum((row) => row.cachedTokens),
      completion: this.sum((row) => row.completionTokens),
      reasoning: this.sum((row) => row.reasoningTokens),
    };
  }

  get split(): CostSplitUsd {
    return {
      inputCacheMiss: this.sum((row) => row.missUsd),
      inputCacheHit: this.sum((row) => row.hitUsd),
      output: this.sum((row) => row.outputUsd),
    };
  }

  private sum(of: (row: CostRow) => number): number {
    return this.rows.reduce((total, row) => total + of(row), 0);
  }
}
